import React from 'react';
import './NVIDIALogo.scss';

interface NVIDIALogoProps {
  width?: number;
  height?: number;
  className?: string;
  fill?: string;
}

const NVIDIALogo: React.FC<NVIDIALogoProps> = ({ 
  width = 110, 
  height = 24, 
  className = '',
  fill = '#fff'
}) => {
  return (
    <svg 
      role="img"
      aria-label="NVIDIA Logo"
      focusable="false" 
      id="NVIDIA_Logo_V" 
      data-name="NVIDIA Logo V" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 974.7 179.71" 
      width={width} 
      height={height}
      className={`nvidia-logo ${className}`}
    >
      <title id="nvidia-logo-title">NVIDIA Logo</title>
      <defs>
        <style>{`.cls-1{fill:${fill}}`}</style>
      </defs>
      <path id="Reg" className="cls-1" d="M962.11 144.13v-2.69h1.73c.94 0 2.23.07 2.23 1.22s-.66 1.47-1.78 1.47h-2.18m0 1.89h1.16l2.68 4.71h2.94l-3-4.9a2.66 2.66 0 002.79-2.91c0-2.56-1.77-3.39-4.76-3.39h-4.33v11.19h2.49V146m12.59-.88c0-6.57-5.11-10.39-10.8-10.39s-10.83 3.81-10.83 10.39 5.1 10.4 10.83 10.4 10.8-3.83 10.8-10.4m-3.12 0a7.67 7.67 0 01-7.68 8 8 8 0 117.71-7.98z" />
      <path id="NVIDIA" className="cls-1" d="M578.25 34v118h33.31V34h-33.31zm-262.07-.2v118.12h33.61V60.23l26.21.09c8.63 0 14.59 2.07 18.74 6.5 5.27 5.62 7.42 14.67 7.42 31.23v53.87h32.56V86.66C434.74 40.08 405 33.8 376 33.8h-59.82zm315.7.2v118h54c28.79 0 38.18-4.79 48.35-15.52 7.18-7.54 11.82-24.08 11.82-42.16 0-16.58-3.93-31.37-10.78-40.58C723 37.18 705.18 34 678.64 34h-46.76zm33 25.68h14.32c20.78 0 34.22 9.33 34.22 33.54s-13.42 33.52-34.17 33.52h-14.32V59.65zM530.21 34l-27.8 93.48L475.77 34h-36l38 118h48l38.45-118h-34zm231.37 118h33.32V34h-33.32v118zM855 34l-46.54 117.88h32.85l7.36-20.88h55.05l7 20.83h35.66L899.48 34H855zm21.63 21.5l20.18 55.22h-41z" />
      <path id="Eye_Mark" data-name="Eye Mark" d="M101.33 53.63V37.39c1.58-.11 3.17-.2 4.79-.25 44.4-1.4 73.53 38.15 73.53 38.15S148.19 119 114.46 119a40.91 40.91 0 01-13.13-2.1V67.67c17.29 2.09 20.76 9.72 31.15 27l23.12-19.45S138.73 53.1 110.29 53.1a83.81 83.81 0 00-9 .53m0-53.62v24.24c1.59-.13 3.19-.23 4.79-.29 61.74-2.08 102 50.64 102 50.64s-46.2 56.18-94.34 56.18a71 71 0 01-12.42-1.09v15a81.75 81.75 0 0010.34.67c44.79 0 77.19-22.87 108.56-49.95 5.2 4.16 26.49 14.29 30.87 18.73-29.83 25-99.33 45.09-138.74 45.09-3.8 0-7.45-.23-11-.57v21.06h170.24V0H101.33zm0 116.89v12.8C59.9 122.3 48.4 79.24 48.4 79.24s19.89-22 52.93-25.61v14h-.06c-17.34-2.05-30.88 14.15-30.88 14.15S78 109 101.33 116.89M27.75 77.37s24.55-36.23 73.58-40V24.25C47 28.61 0 74.6 0 74.6s26.63 77 101.33 84.05v-14c-54.81-6.87-73.58-67.28-73.58-67.28z" fill="#76b900" />
    </svg>
  );
};

export default NVIDIALogo;

